import { viewport } from '../../utils/viewport';

document.addEventListener('alpine:init', () => {
  Alpine.data('section', () => ({
    position: 'relative',
    verticalOffset: -50,
    overflow: 'visible',
    notClickable: false,
    paddingTop: 254,
    paddingTopTablet: 180,
    paddingTopPhone: 104,
    paddingBottom: 254,
    paddingBottomTablet: 180,
    paddingBottomPhone: 104,
    wrapperMaxWidth: 1440,
    gap: 56,
    gapTablet: 56,
    gapPhone: 56,

    set backgrounds(items) {
      while (this.$refs.backgrounds.firstChild) {
        this.$refs.backgrounds.removeChild(this.$refs.backgrounds.lastChild);
      }

      if (items) {
        items.forEach((item) => {
          const div = document.createElement('div');

          div.style.position = 'absolute';
          div.style.width = `${item.width}px`;
          div.style.transform = `translate3d(${item.horizontal_offset}px, ${item.vertical_offset}px, 0)`;

          if (item.position_origin.includes('top')) {
            div.style.top = 0;
          } else if (item.position_origin.includes('bottom')) {
            div.style.bottom = 0;
          }

          if (item.position_origin.includes('right')) {
            div.style.right = 0;
          } else if (item.position_origin.includes('left')) {
            div.style.left = 0;
          }

          div.setAttribute('x-show', item.visibility.map((breakpoint) => `$store.mq.${breakpoint}`).join(' || '));

          const img = document.createElement('img');
          img.src = item.image;
          img.alt = 'Background shape';
          img.style.width = '100%';
          img.style.height = 'auto';
          div.append(img);

          this.$refs.backgrounds.append(div);
        });
      }
    },

    init() {
      viewport.observe(this.$refs.innerBlocks, () => this.$refs.innerBlocks.classList.add('animated'));
    },

    styles() {
      const gap = this.$store.mq.phone ? this.gapPhone : this.$store.mq.tablet ? this.gapTablet : this.gap;
      return `#${this.$refs.innerBlocks.id} > * + *, #${this.$refs.innerBlocks.id} > * > .block-editor-block-list__layout > * + * { margin-top: ${gap}px }`;
    },

    root: {
      ':style'() {
        return {
          height: this.position === 'absolute' ? 0 : 'auto',
          paddingTop:
            (this.$store.mq.phone
              ? this.paddingTopPhone
              : this.$store.mq.tablet
              ? this.paddingTopTablet
              : this.paddingTop) + 'px',
          paddingBottom:
            (this.$store.mq.phone
              ? this.paddingBottomPhone
              : this.$store.mq.tablet
              ? this.paddingBottomTablet
              : this.paddingBottom) + 'px',
          overflow: this.overflow,
          pointerEvents: this.notClickable ? 'none' : 'auto',
        };
      },
    },

    wrapper: {
      ':style'() {
        return {
          zIndex: this.position === 'absolute' ? 1 : 'initial',
          maxWidth: this.wrapperMaxWidth,
          transform: this.position === 'absolute' ? `translate3d(0, ${this.verticalOffset}%, 0)` : 'none',
        };
      },
    },
  }));
});